<template>
  <div>
    <div class='flex flex-row justify-between items-center'>
      <p class="subtitle ml-4">{{ $t("OrderPage[\"Delivery Method\"]") }}</p>
      <span v-if="isBeta&&!isTestPriceCalPage" class='flex flex-row'>
        <el-popover placement="bottom-start" popper-class="dbs-info-popover">
          <div class="dbs-popover-info" style="color: white;padding: 24px 12px;">
            <p class="mb-4">{{ $t("OrderPage[\"Remaining Inventory\"]") }}</p>
            <!-- <div class="flex justify-between">
              <p>Blood Kit</p>
              <p>{{ kitInventoryInfo[1] ? kitInventoryInfo[1] : 0}}</p>
            </div> -->
            <div class="flex justify-between">
              <p>{{ $t("OrderPage[\"Microtube(Blood)\"]") }}</p>
              <p>{{ kitInventoryInfo[5]? kitInventoryInfo[5] : 0}}</p>
            </div>
            <div class="flex justify-between">
              <p>{{ $t("OrderPage[\"Urine(1 tube)\"]") }}</p>
              <p>{{ kitInventoryInfo[6] ? kitInventoryInfo[6] : 0}}</p>
            </div>
            <div class="flex justify-between">
              <p>{{ $t("OrderPage[\"Urine(4 tubes)\"]") }}</p>
              <p>{{ kitInventoryInfo[7] ? kitInventoryInfo[7] : 0 }}</p>
            </div>
            <div class="flex justify-between">
              <p>{{ $t("OrderPage[\"Stool\"]") }}</p>
              <p>{{ kitInventoryInfo[8] ? kitInventoryInfo[8] : 0 }}</p>
            </div>
            <div class="flex justify-between">
              <p>{{ $t("OrderPage[\"DBS Card\"]") }}</p>
              <p>{{ kitInventoryInfo[9] ? kitInventoryInfo[9] : 0 }}</p>
            </div>
            <div class="flex justify-between">
              <p>{{ $t("OrderPage[\"Saliva(1 tube)\"]") }}</p>
              <p>{{ kitInventoryInfo[10] ? kitInventoryInfo[10] : 0 }}</p>
            </div>
            <div class="flex justify-between">
              <p>{{ $t("OrderPage[\"Saliva(4 tubes)\"]") }}</p>
              <p>{{ kitInventoryInfo[11] ? kitInventoryInfo[11] : 0 }}</p>
            </div>
            <div class="flex justify-between">
              <p>{{ $t("OrderPage[\"Non-Blood Kits Return Label\"]") }}</p>
              <p>{{ kitInventoryInfo[13] ? kitInventoryInfo[13] : 0 }}</p>
            </div>
            <!-- <div class="flex justify-between">
              <p>Blood Kits Return Label</p>
              <p>{{ kitInventoryInfo[12] ? kitInventoryInfo[12] : 0 }}</p>
            </div> -->
          </div>
          <template v-slot:reference>
            <span class="check-inventory-text">{{ $t("OrderPage[\"Check Remaining Inventory\"]") }}</span> 
          </template>
        </el-popover>
      </span>
    </div>
    <DeliveryMethodSelector 
      v-if="sampleTypes.blood.length > 0"
      class="mt-4"
      id="blood-kit-selector"
      :delivery-method-name="isUSCAUser ? $t('OrderPage[\'Blood Kit\']') : $t('OrderPage[\'Blood Kit & Return Label\']')"
      :sample-types="sampleTypes.blood"
      selector-id="blood-selector-options"
      :delivery-value="deliveryMethod.blood"
      @change="changeDeliveryMethod('blood', $event)"
    />
    <DeliveryMethodSelector 
      v-if="sampleTypes.nonBlood.length > 0"
      class="mt-5"
      id="non-blood-kit-selector"
      :delivery-method-name="isUSCAUser ? $t('OrderPage[\'Non-Blood Kit\']') : $t('OrderPage[\'Non-Blood Kit & Return Label\']')"
      :sample-types="sampleTypes.nonBlood"
      selector-id="non-blood-selector-options"
      :delivery-value="deliveryMethod.nonBlood"
      :disabled="!isNonBloodKitDeliveryMethodSelectable"
      @change="changeDeliveryMethod('nonBlood', $event)"
    />
    <DeliveryMethodSelector
      v-if="sampleTypes.dryIce.length > 0" 
      class="mt-5"
      id="dry-ice-kit-selector"
      :delivery-method-name="isUSCAUser ? 'Dry Ice Kit' : 'Dry Ice Kit & Return Label'"
      :sample-types="sampleTypes.dryIce"
      selector-id="dry-ice-selector-options"
      :delivery-value="deliveryMethod.dryIce"
      @change="changeDeliveryMethod('dryIce', $event)"
    />
    <div v-if="selectedMerchList.length > 0" class="mt-5 merch">
      <span class="mb-2 pl-4">{{ $t("OrderPage[\"Practice Product\"]") }}</span>
      <Alert :height="148" type="warning" class="px-3 flex items-center mt-2 warning-text">
        <img src="@/assets/orderTest/info_icon_yellow_24px.svg" class="pr-2" alt="error outline">
        <p>{{ $t("OrderPage[\"Please note that Vibrant does not handle the distribution or shipping of your practice products. The 'Delivery Method' selected here is for Vibrant's internal testing purposes only. You will need to manage the shipment of your practice products independently.\"]") }}</p>
      </Alert>
    </div>
    <Alert type="warning" v-if="isBeta&&isShowTubeInfoWarningAlert&&!isTestPriceCalPage">
      <div class="flex items-center restriction-box">
        <img src="@/assets/orderTest/info_icon_yellow_24px.svg" class="pl-3 px-2" alt="error outline">
        <div>
          <span class="restriction-text">{{ $t("OrderPage[\"From our records, it seems like you don't have enough kits/return label to supply to patient on your hand. You can either\"]") }}
            <span class="order-here-url" @click="handleOrderKitUrl">{{ $t("OrderPage[\"Order Here\"]") }}</span> 
            {{ $t("OrderPage[\"for more bulk kits/return label, or ship it back to us by yourself, or choose 'kits ship to patient'\"]") }}</span>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import DeliveryMethodSelector  from "./DeliveryMethodSelector.vue";
import Alert from "@/views/va-orderTest/components/Alert.vue";
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
export default {
  components: {
    DeliveryMethodSelector,
    Alert,   
  },
  props: {
    defaultSettings:{
      type: Object,
      default: () => {},
    },
    orderDraft: {
      type: Object,
      default: () => {},
    },
    kitInventoryInfo: {
      type: Object,
      default: () => {}
    },
    tubeInfoWarningAlertBlood: {
      type: Boolean,
      default: false
    },
    tubeInfoWarningAlertNonBlood: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      deliveryOptions: [
        {
          value: "shipToPatient",
          label: this.$t("OrderPage[\"Ship to patient\"]"),
        },
        {
          value: "suppliedByClient",
          label: this.$t("OrderPage[\"Supplied by Client/Office/Phlebotomist\"]"),
        },
      ],
      isNonBloodKitDeliveryMethodSelectable: true,
    }
  },

  computed: {
    ...mapState("orderTest", ["isBackFromCheckoutPage"]),
    ...mapState("orderTest/order", ["deliveryMethod"]),
    ...mapState("orderTest/orderDraft", ["editOrderItemList"]),
    ...mapGetters("orderTest", ["selectedItemList"]),
    ...mapState("orderTest/user", ["patientCountry","userInfo"]),
    ...mapGetters("orderTest/merchandise", ["selectedMerchList"]),

    isUSCAUser() {
      return this.patientCountry === 'US' || this.patientCountry === 'CA'
    },

    isShowTubeInfoWarningAlert() {
      let suppliedByClientBlood = this.sampleTypes.blood.length > 0&&this.deliveryMethod.blood === 'suppliedByClient'
      let suppliedByClientNonBlood = this.sampleTypes.nonBlood.length > 0&&this.deliveryMethod.nonBlood === 'suppliedByClient'
      if(this.tubeInfoWarningAlertBlood && suppliedByClientBlood) {
        return true
      } 
      if(this.tubeInfoWarningAlertNonBlood && suppliedByClientNonBlood) {
        return true
      }
      return false
    },
    
    sampleTypes() {
      let result = {
        blood: new Set(),
        nonBlood: new Set(),
        dryIce: new Set()
      };
      this.editOrderItemList.concat(this.selectedItemList).forEach(item => {
        if (item.sampleTypeSets) {
          ["blood", "nonBlood", "dryIce"].forEach(prop => {
            result[prop] = new Set([...item.sampleTypeSets[prop], ...result[prop]]);
          });
        }
      });
      return {
        blood: [...result.blood],
        nonBlood: [...result.nonBlood],
        dryIce: [...result.dryIce]
      }
    },
    isBeta() {
      if (_.isEmpty(this.userInfo) || !this.userInfo.beta_program_enabled || _.isEmpty(this.userInfo.beta_programs)) {
        return false;
      }
      return this.userInfo.beta_programs.includes("general_beta1");
    },
    isTestPriceCalPage() {
      return false;
    }
  },
  

  watch: {
    defaultSettings() {
      this.getDefaultDeliveryMethods();
    },
  },

  mounted() {
    if (!this.isBackFromCheckoutPage){
      this.getDefaultDeliveryMethods();
    }
  },

  methods: {
    handleOrderKitUrl() {
      this.$router.push('/OrderKit')
    },
    getDefaultDeliveryMethods() {
      if (this.orderDraft && !_.isEmpty(this.orderDraft)) {
        return;
      }
      if (!this.defaultSettings) {
        return;
      }
      ["blood", "nonBlood", "dryIce"]
        .forEach(prop => {
          let settingProp = prop + "KitDeliveryMethod";
          if (this.defaultSettings[settingProp]) {
            let value = this.defaultSettings[settingProp] === "N/A" 
              ? "" : this.defaultSettings[settingProp];
            let deliveryObj = { kit: prop, deliveryMethod: value };
            this.$store.dispatch("orderTest/order/setDeliveryMethod", deliveryObj);
          }
        });
      if ("isNonBloodKitDeliveryMethodSelectable" in this.defaultSettings) {
        this.isNonBloodKitDeliveryMethodSelectable = 
          this.defaultSettings.isNonBloodKitDeliveryMethodSelectable;
      }
    },
    changeDeliveryMethod(methodName, value) {
      let deliveryObj = { kit: methodName, deliveryMethod: value };
      this.$store.dispatch("orderTest/order/setDeliveryMethod", deliveryObj);
    }
  }
}
</script>


<style scoped>
.subtitle {
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.4576px;
}
.merch {
  font-size: 14px;
}
.warning-text {
  font-family: 'Roboto';
  color: #E0961E;
}

.check-inventory-text {
  color: var(--Blue-60, var(--color-Cyan-000, #20A7C1));
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
}

.restriction-text {
  color: var(--color-Yellow-000, #E0961E);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.restriction-box {
  width: 368px;
  background: var(--color-Functional-Yellow-alert-bg, #FDF0E3);
  margin-top: 12px;
}

.order-here-url {
  color: var(--Blue-tag-text, var(--color-Yellow-000, #3498DB));
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
}
</style>